import { Interpolation } from '@emotion/css'
import { Theme } from 'src/theme/theme'

const styles = {
  paymentWrapper: {
    padding: 40,
    width: 'fit-content',
    margin: 'auto',
    '@media (max-width: 668px)': {
      padding: 20,
      width: '100%',
    },
  } as Interpolation,
  cardsContainer: {
    display: 'flex',
    '@media (max-width: 668px)': {
      flexDirection: 'column',
    },
  } as Interpolation,
  cardSection: {
    marginRight: 300,
    '@media (max-width: 668px)': {
      marginRight: 0,
      marginBottom: 40,
    },
  },
  header: {
    marginBottom: 100,
    fontWeight: 600,
    fontSize: 35,
    '@media (max-width: 668px)': {
      marginBottom: 30,
    },
  },
  smallHeader: {
    fontWeight: 600,
    marginBottom: 25,
  },
  blah: {
    marginBottom: 25,
  },
  link: {
    color: 'rgb(118, 184, 235)',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  formCard: (theme: Theme): Interpolation => ({
    background: theme.colors.white,
    padding: '63px 15px 25px 15px',
    borderRadius: 10,
    position: 'absolute',
    top: '79%',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: -1,
  }),
}

export default styles
